import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "feelingHeadingDv"
}
const _hoisted_2 = { class: "profile_feeling" }
const _hoisted_3 = {
  key: 0,
  class: "feeling c-pointer"
}
const _hoisted_4 = { class: "headingStart" }
const _hoisted_5 = { class: "nextinfoLeftInfoDv" }
const _hoisted_6 = {
  key: 1,
  class: "feeling c-pointer"
}
const _hoisted_7 = {
  class: "headingStart",
  style: {"margin-inline":"7px"}
}
const _hoisted_8 = { class: "nextinfoLeftInfoDv" }
const _hoisted_9 = {
  key: 1,
  class: "text_post"
}
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.post && (_ctx.post.feeling || _ctx.post.userLocation))
      ? (_openBlock(), _createElementBlock("h6", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.post.feeling)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t("common.common.is_feeling")), 1),
                  _createVNode(_component_IconComponent, {
                    path: "/feelings",
                    className: "infoLeftDvIconInfo",
                    icon: `${_ctx.post.feeling}.svg`
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.post.feeling), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.post.userLocation && Object.keys(_ctx.post.userLocation).length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("common.common.in")), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.post.userLocation?.displayName), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.post.body && _ctx.post.body !== '.')
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", {
            ref: "textElement",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleTextElementClicked && _ctx.handleTextElementClicked(...args))),
            class: _normalizeClass(["post_message description_text", _ctx.post._id]),
            innerHTML: _ctx.post.body?.replace('target=', '')
          }, null, 10, _hoisted_10),
          (_ctx.isTruncated)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "anchor_tag--more",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.checkTextLength(false)), ["stop"]))
              }, _toDisplayString(_ctx.$t("common.common.see_more")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showQuotedBlock)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: _normalizeClass(["text_post", { quotedText: _ctx.post.quotedImage, detailQuoted: _ctx.isDetailView }]),
          style: _normalizeStyle(_ctx.getStyle())
        }, [
          _createElementVNode("div", {
            ref: "quotedTextElement",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleTextElementClicked && _ctx.handleTextElementClicked(...args))),
            class: _normalizeClass(["post_message description_text", [_ctx.post._id, { expanded: _ctx.isDetailView }]]),
            innerHTML: _ctx.quotedDisplayText
          }, null, 10, _hoisted_11),
          (_ctx.isQuotedTruncated && !_ctx.isDetailView)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "anchor_tag--more",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.checkQuotedTextLength(false)), ["stop"]))
              }, _toDisplayString(_ctx.$t("common.common.see_more")), 1))
            : _createCommentVNode("", true)
        ], 6))
      : _createCommentVNode("", true)
  ], 64))
}